import React from 'react';

const Logo = () => (
  <svg width="261" height="93" viewBox="0 0 261 93" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M69.3677 2.13423L4.65171 42.0295C-1.48922 45.8066 0.518396 55.1313 7.66313 56.1345L40.8478 60.6198C42.8554 60.9149 44.6858 61.9182 45.9849 63.5116L67.1239 89.538C71.6705 95.0856 80.6457 91.8987 80.7048 84.7576L81 8.68509C81 2.7244 74.4457 -0.993652 69.3677 2.13423Z"
      stroke="url(#paint0_linear_0_1)"
      strokeMiterlimit="10"
    />
    <path
      d="M51.5672 13.08L62.7327 6.22396C66.1592 4.09623 70.5309 6.57858 70.5309 10.5976L70.3536 54.3935C70.3536 56.8167 67.2816 57.9397 65.7456 56.0484L56.4706 44.6414C55.1709 43.0456 53.3395 42.0408 51.3309 41.7453L44.9506 40.9178"
      stroke="url(#paint1_linear_0_1)"
      strokeMiterlimit="10"
    />
    <path
      d="M80.8025 69.4574V75.892C80.8025 80.6737 74.7201 82.8579 71.7084 79.0798L51.2763 54.0498C49.9771 52.4559 48.1465 51.4523 46.1387 51.1572L38.6981 50.1536C36.277 49.7994 35.6274 46.6707 37.6942 45.3719L60.016 31.6172"
      stroke="url(#paint2_linear_0_1)"
      strokeMiterlimit="10"
    />
    <path
      d="M59.9437 48.7966L60.0027 31.6693L60.0618 24.464C60.0618 22.456 57.8187 21.1567 56.1069 22.2198L14.4928 47.7926C10.4199 50.3322 11.7185 56.5925 16.4997 57.2422L27.7739 58.7777"
      stroke="url(#paint3_linear_0_1)"
      strokeMiterlimit="10"
    />
    <path
      d="M104.968 34L108.068 49.4533H108.626L111.726 34H117.212L120.312 49.4533H120.87L123.97 34H128L123.97 53H117.398L114.67 38.465H114.299L111.571 53H104.999L101 34H104.968Z"
      fill="white"
    />
    <path
      d="M131 27H134.805V36.6553H134.989C135.357 36.0874 135.787 35.5825 136.339 35.1723C137.628 34.1626 139.193 33.6578 140.789 33.6893C145.3 33.6893 148 36.4345 148 41.6723V53H144.195V42.0194C144.195 38.6432 142.753 37.1917 139.868 37.1917C136.984 37.1917 134.805 39.432 134.805 42.7451V52.9684H131V27Z"
      fill="white"
    />
    <path
      d="M160.5 34C165.809 34 170 38.1648 170 43.4848V44.7312H154.85C155.44 47.7712 157.768 49.5648 160.5 49.5648C162.394 49.5648 163.76 48.9872 164.598 48.3184C165.064 47.9536 165.467 47.528 165.809 47.072H169.814C169.348 48.1664 168.696 49.1696 167.889 50.0512C166.43 51.48 164.194 53 160.5 53C155.191 53 151 48.8352 151 43.5152C151 38.1952 155.191 34 160.5 34ZM165.995 41.6912C165.592 39.5328 163.822 37.4048 160.5 37.4048C159.227 37.3744 157.954 37.8 156.961 38.5904C155.967 39.3808 155.284 40.4752 155.005 41.7216H165.995V41.6912Z"
      fill="white"
    />
    <path
      d="M173 34.1891H177.066V36.9434H177.262C177.59 36.3801 177.984 35.8793 178.508 35.4724C179.656 34.5021 181.131 33.97 182.672 34.0013H185V37.6946H182.475C179.393 37.6946 177.066 39.7291 177.066 42.859V53H173V34.1891Z"
      fill="white"
    />
    <path
      d="M195.5 34C200.809 34 205 38.1648 205 43.4848V44.7312H189.85C190.44 47.7712 192.768 49.5648 195.5 49.5648C197.394 49.5648 198.76 48.9872 199.598 48.3184C200.064 47.9536 200.467 47.528 200.809 47.072H204.814C204.348 48.1664 203.696 49.1696 202.889 50.0512C201.43 51.48 199.194 53 195.5 53C190.191 53 186 48.8352 186 43.5152C186 38.1952 190.191 34 195.5 34ZM200.964 41.6912C200.56 39.5328 198.822 37.4048 195.469 37.4048C194.196 37.3744 192.923 37.8 191.93 38.5904C190.936 39.3808 190.253 40.4752 189.974 41.7216H200.964V41.6912Z"
      fill="white"
    />
    <path
      d="M210.956 34L214.883 49.4533H217.178L221.104 34H225L220.017 53H211.983L207 34H210.956Z"
      fill="white"
    />
    <path
      d="M236.5 34C241.809 34 246 38.1648 246 43.4848V44.7312H230.85C231.44 47.7712 233.768 49.5648 236.5 49.5648C238.394 49.5648 239.76 48.9872 240.598 48.3184C241.064 47.9536 241.467 47.528 241.809 47.072H245.814C245.348 48.1664 244.696 49.1696 243.889 50.0512C242.43 51.48 240.194 53 236.5 53C231.191 53 227 48.8352 227 43.5152C227 38.1952 231.191 34 236.5 34ZM241.964 41.6912C241.56 39.5328 239.822 37.4048 236.469 37.4048C235.196 37.3744 233.923 37.8 232.93 38.5904C231.936 39.3808 231.253 40.4752 230.974 41.7216H241.964V41.6912Z"
      fill="white"
    />
    <path
      d="M249 34.1891H253.044V36.9434H253.241C253.57 36.3801 253.997 35.8793 254.49 35.4724C255.641 34.5021 257.121 33.97 258.666 34.0013H261V37.6946H258.501C255.411 37.6946 253.077 39.7291 253.077 42.859V53H249.033V34.1891H249Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_0_1"
        x1="35.6966"
        y1="22.0205"
        x2="79.1853"
        y2="86.1172"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#36E0FC" />
        <stop offset="0.518279" stopColor="#00BAFF" />
        <stop offset="1" stopColor="#0270BA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_0_1"
        x1="38.578"
        y1="21.595"
        x2="84.7617"
        y2="84.7973"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#36E0FC" />
        <stop offset="0.518279" stopColor="#00BAFF" />
        <stop offset="1" stopColor="#0270BA" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_0_1"
        x1="33.2701"
        y1="24.8709"
        x2="82.4931"
        y2="88.4491"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#36E0FC" />
        <stop offset="0.518279" stopColor="#00BAFF" />
        <stop offset="1" stopColor="#0270BA" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_0_1"
        x1="34.354"
        y1="23.7717"
        x2="80.8114"
        y2="90.6001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#36E0FC" />
        <stop offset="0.518279" stopColor="#00BAFF" />
        <stop offset="1" stopColor="#0270BA" />
      </linearGradient>
    </defs>
  </svg>
);

export default Logo;
